import styled from '@emotion/styled';

export const SectionHeading = styled.h3`
  ${({ theme }) => theme.text.lead};
  margin: ${({ theme }) => theme.spacing([0, 0, 1])};
  font-weight: 600;
`;

export const FieldHeading = styled.h4`
  ${({ theme }) => theme.text.body1};
  margin: ${({ theme }) => theme.spacing([0, 0, 4])};
  font-weight: 600;

  &:last-child {
    margin: 0;
  }
`;
